export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHklEQVR42mNgYGD4TyFm+P8fiMjBowaMGkBdAyjBANp11jgQILOmAAAAAElFTkSuQmCC"